import { MapPinIcon } from "@heroicons/react/24/outline";
import { Badge } from "components";
import { formatSalary } from "helpers";
import { JobDetails } from "services/jobs";

/** The job's real attributes; anything not set is left out. */
export const JobFacts = ({ job }: { job: JobDetails }) => {
  const salary = formatSalary(job);
  const facts: [string, string | null | undefined][] = [
    ["Department", job.department],
    ["Employment type", job.jobType],
    ["Workplace", job.workplaceType],
    ["Level", job.workLevel],
    ["Salary", salary],
  ];

  return (
    <div className="flex flex-col gap-4">
      {job.jobLocation && (
        <Badge className="flex max-w-max items-center gap-2 bg-orange-100 text-orange-800">
          <MapPinIcon className="w-4" aria-hidden="true" />
          {job.jobLocation}
        </Badge>
      )}
      <dl className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        {facts
          .filter(([, value]) => value && String(value).trim())
          .map(([label, value]) => (
            <div key={label}>
              <dt className="text-sm text-gray-500">{label}</dt>
              <dd className="font-medium text-gray-900">{value}</dd>
            </div>
          ))}
      </dl>
      {job.skills && job.skills.length > 0 && (
        <div>
          <h2 className="mb-2 text-sm text-gray-500">Skills</h2>
          <ul className="flex flex-wrap gap-2">
            {job.skills.map((skill) => (
              <li key={skill}>
                <Badge className="bg-orange-50 text-orange-700">{skill}</Badge>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
